/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PipelineMapList } from './PipelineMapList';
import {
    PipelineMapListFromJSON,
    PipelineMapListFromJSONTyped,
    PipelineMapListToJSON,
    PipelineMapListToJSONTyped,
} from './PipelineMapList';

/**
 * 
 * @export
 * @interface PaginatedPipelineMapListList
 */
export interface PaginatedPipelineMapListList {
    /**
     * 
     * @type {string}
     * @memberof PaginatedPipelineMapListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedPipelineMapListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<PipelineMapList>}
     * @memberof PaginatedPipelineMapListList
     */
    results: Array<PipelineMapList>;
}

/**
 * Check if a given object implements the PaginatedPipelineMapListList interface.
 */
export function instanceOfPaginatedPipelineMapListList(value: object): value is PaginatedPipelineMapListList {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedPipelineMapListListFromJSON(json: any): PaginatedPipelineMapListList {
    return PaginatedPipelineMapListListFromJSONTyped(json, false);
}

export function PaginatedPipelineMapListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedPipelineMapListList {
    if (json == null) {
        return json;
    }
    return {
        
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(PipelineMapListFromJSON)),
    };
}

export function PaginatedPipelineMapListListToJSON(json: any): PaginatedPipelineMapListList {
    return PaginatedPipelineMapListListToJSONTyped(json, false);
}

export function PaginatedPipelineMapListListToJSONTyped(value?: PaginatedPipelineMapListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(PipelineMapListToJSON)),
    };
}

